import { Component, OnInit } from '@angular/core';


@Component({
	templateUrl: './library.component.html',
	styleUrls: ['./library.component.scss']
})

export class LibraryComponent implements OnInit {

	constructor() { }

	ngOnInit() { }
}
